import { html, unsafeCSS } from 'lit';
import { BaseElement, customElement } from '../base-element';
import styles from './nav-controls.scss?inline';

@customElement('ps-nav-controls')
export class NavControlsWC extends BaseElement {
  static styles = unsafeCSS(styles);

  render() {
    return html`
      <div class="c-nav-controls">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-nav-controls': NavControlsWC;
  }
  enum PSElementTagNameMap {
    'ps-nav-controls' = 'ps-nav-controls',
  }
}
